const datadogLogger = require('@datadog/browser-logs');
const guidUtil = require('../guid/guidUtil');

module.exports.createTracingContext = function(url, verb)
{
    var tracingContext = {};
    tracingContext.traceId = guidUtil.generateGuid();

    try
    {
        var currentContext = datadogLogger.datadogLogs.getGlobalContext();
        tracingContext.originService = "RMS.APP.CUSTOMER.WEB";
        tracingContext.originVersion = currentContext.version;
        tracingContext.originEnv = currentContext.env;

        tracingContext.originFranchisorId = currentContext.franchisorId;
        tracingContext.originFranchisorCode = currentContext.franchisorCode;
        tracingContext.originFranchisorName = this.sanitizeName(currentContext.franchisorName);
        tracingContext.originFranchiseeId = currentContext.franchiseeId;
        tracingContext.originFranchiseeCode = currentContext.franchiseeCode;
        tracingContext.originFranchiseeName = this.sanitizeName(currentContext.franchiseeName);
        tracingContext.originPropertyId = currentContext.propertyId;
        tracingContext.originPropertyCode = currentContext.propertyCode;
        tracingContext.originPropertyName = this.sanitizeName(currentContext.propertyName);


        tracingContext.originApplicationId = currentContext.applicationId;
        tracingContext.originApplicationTitle = this.sanitizeName(currentContext.applicationTitle);
        tracingContext.tableNumber = currentContext.tableNumber;
        tracingContext.themeId = currentContext.themeId;
        tracingContext.venueCode = currentContext.venueCode;
        tracingContext.paymentLinkId = currentContext.paymentLinkId;
        tracingContext.currentMode = currentContext.currentMode;
    
        tracingContext.originUrl = url;
        tracingContext.originVerb = verb;

        inferModuleAndAction(tracingContext, url, verb);
    }
    catch(error)
    {

    }
    return tracingContext;
}

function inferModuleAndAction(tracingContext, url, verb)
{
    tracingContext.originModule = url;
    tracingContext.originAction = verb;
}

module.exports.sanitizeName = function (input)
{
    if (typeof input !== 'string')
        return null;

    return input.replace(/[^A-Za-z0-9@&,'\.\-\_\ \(\)\[\]]/g, "");
}